import { gql } from '@apollo/client';
import { createApolloQueriesString } from '../../helpers/apolloHelpers';
import { defaultResponse } from './defaultResponse';

const [
  parametersTypeString,
  parametersAssignString,
] = createApolloQueriesString([
  ['token', 'String!'],
]);
export default function VERIFY_INVITE_TOKEN(responseString = '') {
  return gql`
    query VerifyInviteToken(${parametersTypeString}) {
      verifyInviteToken(${parametersAssignString}) {
        ${defaultResponse}
      }
    }
  `;
}
